import React from 'react'
import { Link as RouterLink } from 'react-router-dom'
import { styled } from '@mui/material/styles'
import { Grid, Link, Container, Typography, Stack } from '@mui/material'
import { PATH_PAGE } from '@/routes/paths'
import Logo from '../../components/Logo'
import SocialsButton from '../../components/SocialsButton'

const LINKS = [
  {
    headline: 'click77',
    children: [
      { name: 'About us', href: PATH_PAGE.about },
      { name: 'Contact us', href: PATH_PAGE.contact },
      { name: 'FAQs', href: PATH_PAGE.faqs }
    ]
  },
  {
    headline: 'Legal',
    children: [
      { name: 'Terms and Condition', href: '#' },
      { name: 'Privacy Policy', href: '#' }
    ]
  },
  {
    headline: 'Contact',
    children: [
      { name: 'support@click77.app', href: '#' },
      { name: 'Jerusalem, Israel', href: '#' }
    ]
  }
]

const RootStyle = styled('div')(({ theme }) => ({
  position: 'relative',
  backgroundColor: theme.palette.background.default
}))

export default function MainFooter() {
  return (
    <RootStyle>
      <Container sx={{ pt: 10 }}>
        <Grid container justifyContent={{ xs: 'center', md: 'space-between' }} sx={{ textAlign: { xs: 'center', md: 'left' } }}>
          <Grid item xs={12} sx={{ mb: 3 }}>
            <Logo sx={{ mx: { xs: 'auto', md: 'inherit' } }} />
          </Grid>
          <Grid item xs={8} md={3}>
            <Typography variant="body2" sx={{ pr: { md: 5 } }}>
              Click77 is a project that provides of platform for any brand, while offering users a game, it allows brands to promote their products and stay on top mind.
            </Typography>

            <Stack direction="row" justifyContent={{ xs: 'center', md: 'flex-start' }} sx={{ mt: 5, mb: { xs: 5, md: 0 } }}>
              <SocialsButton
                sx={{ mx: 0.5 }}
                links={{
                  facebook: 'https://www.facebook.com/CLICK-77-102275205785847',
                  linkedin: 'https://www.linkedin.com/company/click-77',
                  instagram: ''
                }}
              />
            </Stack>
          </Grid>

          <Grid item xs={12} md={7}>
            <Stack spacing={5} direction={{ xs: 'column', md: 'row' }} justifyContent="space-between">
              {LINKS.map((list) => (
                <Stack key={list.headline} spacing={2}>
                  <Typography component="p" variant="overline">
                    {list.headline}
                  </Typography>
                  {list.children.map((link) => (
                    <Link to={link.href} key={link.name} color="inherit" variant="body2" component={RouterLink} sx={{ display: 'block' }}>
                      {link.name}
                    </Link>
                  ))}
                </Stack>
              ))}
            </Stack>
          </Grid>
        </Grid>

        <Typography
          component="p"
          variant="body2"
          sx={{
            mt: 10,
            pb: 5,
            fontSize: 13,
            textAlign: { xs: 'center', md: 'left' }
          }}>
          © 2021. All rights reserved
        </Typography>
      </Container>
    </RootStyle>
  )
}
